import { AxiosError } from 'axios';
import { put, call, takeLatest } from 'redux-saga/effects';
import { types, Hardware, UpdateHardwareRequest, CreateHardwareRequest, DeleteHardwareRequest } from './types';
import { API } from 'services/api/base';
import { getErrorCode } from 'services/api/normalizer';

export function* getHardwareAsync() {
  yield put({ type: types.GET_HARDWARE.PENDING, payload: true });

  try {
    const api = new API(`hardware`);
    const response: Hardware[] = yield call(api.getAll);

    yield put({ type: types.GET_HARDWARE.SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.GET_HARDWARE.ERROR, payload: 'Failed to get hardware' });
  } finally {
    yield put({ type: types.GET_HARDWARE.PENDING, payload: false });
  }
}

export function* createHardwareAsync({ payload }: CreateHardwareRequest) {
  yield put({ type: types.CREATE_HARDWARE.PENDING, payload: true });

  try {
    const hardwareApi = new API(`hardware`);
    yield call(hardwareApi.create, payload);

    yield put({ type: types.CREATE_HARDWARE.SUCCESS });
  } catch (err) {
    const errorCode = getErrorCode(err as AxiosError) as number;

    if (errorCode >= 400 && errorCode < 500) {
      yield put({ type: types.CREATE_HARDWARE.ERROR, payload: 'Invalid credentials' });
    } else if (errorCode >= 500) {
      yield put({ type: types.CREATE_HARDWARE.ERROR, payload: 'Server error' });
    } else {
      yield put({ type: types.CREATE_HARDWARE.ERROR, payload: 'Uh oh! Something went wrong. Please try again.' });
    }
  } finally {
    yield put({ type: types.CREATE_HARDWARE.PENDING, payload: false });
  }
}

export function* updateHardwareAsync({ payload }: UpdateHardwareRequest) {
  yield put({ type: types.UPDATE_HARDWARE.PENDING, payload: true });

  try {
    const api = new API(`hardware`);
    const response: Hardware = yield call(api.update, payload);

    yield put({ type: types.UPDATE_HARDWARE.SUCCESS, payload: response });
  } catch (err) {
    const errorCode = getErrorCode(err as AxiosError) as number;

    if (errorCode >= 400 && errorCode < 500) {
      yield put({ type: types.UPDATE_HARDWARE.ERROR, payload: 'Invalid credentials' });
    } else if (errorCode >= 500) {
      yield put({ type: types.UPDATE_HARDWARE.ERROR, payload: 'Server error' });
    } else {
      yield put({ type: types.UPDATE_HARDWARE.ERROR, payload: 'Uh oh! Something went wrong. Please try again.' });
    }
  } finally {
    yield put({ type: types.UPDATE_HARDWARE.PENDING, payload: false });
  }
}

export function* deleteHardwareAsync({ payload }: DeleteHardwareRequest) {
  const { id } = payload;
  yield put({ type: types.DELETE_HARDWARE.PENDING, payload: true });

  try {
    const areaApi = new API(`hardware`);
    yield call(areaApi.destroy, id);

    yield put({ type: types.DELETE_HARDWARE.SUCCESS });
  } catch (err) {
    const errorCode = getErrorCode(err as AxiosError) as number;

    if (errorCode >= 400 && errorCode < 500) {
      yield put({ type: types.DELETE_HARDWARE.ERROR, payload: 'Invalid credentials' });
    } else if (errorCode >= 500) {
      yield put({ type: types.DELETE_HARDWARE.ERROR, payload: 'Server error' });
    } else {
      yield put({ type: types.DELETE_HARDWARE.ERROR, payload: 'Uh oh! Something went wrong. Please try again.' });
    }
  } finally {
    yield put({ type: types.DELETE_HARDWARE.PENDING, payload: false });
  }
}

export const sagas = [
  takeLatest(types.GET_HARDWARE.REQUEST, getHardwareAsync),
  takeLatest(types.UPDATE_HARDWARE.REQUEST, updateHardwareAsync),
  takeLatest(types.CREATE_HARDWARE.REQUEST, createHardwareAsync),
  takeLatest(types.DELETE_HARDWARE.REQUEST, deleteHardwareAsync)
];
